import { useEventListener } from '@ovpn-ui/utils';
export function useSidebarToggleEvent(eventId, onSidebarToggle) {
  useEventListener(eventId, e => {
    onSidebarToggle(e.detail.opened);
  });
}